import { Link, Outlet } from "react-router";
import { useTranslation } from "react-i18next";

export default function AccountLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <Link to="/account" className="font-semibold">
            {t("account.layout.title", "Mi cuenta")}
          </Link>
          <nav className="flex gap-4 text-sm">
            <Link to="/account/addresses" className="hover:underline">
              {t("addresses.nav", "Domicilios")}
            </Link>
            <Link to="/account/orders" className="hover:underline">
              {t("orders.history.nav", "Mis pedidos")}
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
